<!--
  @Author: HanJianXin
  @Desc: 信息列表共用组件
  @Date: 2019-08-01 17:17:17
-->
<template>
    <div class="main-header">
        <div class="main-header-message">
          <ul>
              <li v-for="(item,index) in data" :style="(index+1)%3==0?{marginRight:'0px'}:0" :key="index" class="clearfix">
                    <span class="message-title" >{{item.label}}</span>
                    <span class="message-con" >
                        <!-- 如果传入的item包含tooltip为true，出现浮窗，默认false-DKing -->
                        <el-tooltip
                            v-if='item.label == "文件名称：" || item.tooltip'
                            :content="item.value"
                            placement="bottom"
                            effect="light"
                            >
                            <span class="ellipsis">{{item.value}}</span>
                        </el-tooltip>
                        <span v-else>{{item.value}}</span>
                    </span>
              </li>
          </ul>
        </div>
      </div>
</template>
<script>

export default {
    name:'my-message-list',
    props:{
        data:{
            type:Array,
            default:[],
        }
    },
    data(){
        return{

        }
    },

    components:{
    },
    created(){
        // console.log(this.data)
    },
    data(){
        return{
        }
    },
    methods:{

    }
}
</script>
<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/components/my-messageList/src/main.vue